// extracted by mini-css-extract-plugin
export var formContainer = "_bq-0";
export var message = "_bq-1";